import React from "react";
import useRolesLogic from "./useRolesLogic";
import RolesView from "./RolesView.jsx";

export default function Roles() {
  const logic = useRolesLogic();
  return <RolesView {...logic} />;
}
